/**
 *  Модель для работы с пользователями
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';
import UsersService from '../services/UsersService';
import { IUser } from './types';

type IState = IUser;

const initialState: IState = {
  id: '',
  username: '',
  name: '',
  lastname: '',
  secondname: '',
  fullName: '',
  phone: '',
  email: '',
  role: '',
  title: '',
  brigadeId: null,
  brigadeName: '',
  mapColor: '',
  immobilizedTimeMinutes: 0,
  workshiftDurationHours: 0,
  workshiftBreakMinutes: 0,
  descr: '',
  lead: null,
  protectionsList: [],
  birthday: '',
  tabularNumber: '',
  photoContent: '',
  photoContentType: ''
};

export const user = createModel<RootModel>()({
  state: initialState as IState,
  reducers: {
    setUser(state: IState, payload: IUser): IState {
      return { ...state, ...payload };
    }
  },
  effects: () => ({
    async getUser() {
      try {
        const { data } = await UsersService.getByToken({ preview: true });
        this.setUser(data);
      } catch (error) {
        return error;
      }
    }
  })
});
